<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="new-provider-header">
                <div>Novo Vendedor - {{ provider ? provider.name : "" }}</div>
                <span v-on:click="close" class="material-icons new-provider-close-icon">cancel</span>
            </div>
            <div class="new-provider-body">
                <div class="new-provider-body-buttons">
                    <StandardButton class="new-provider-buttons-size" :action="close" :iconName="'arrow_back'" :text="'Voltar'" />
                    <StandardButton class="new-provider-buttons-size" :action="save" :iconName="'save'" :text="'Salvar'" />
                </div>
                <div v-if="message" class="new-provider-error-message">
                    {{ message }}
                </div>
                <div class="new-provider-body-separator">
                    <div class="new-provider-body-text-title">Informações do usuário</div>
                    <div class="new-provider-body-input-line" v-if="registration">
                        <StandardInput
                            class="new-provider-body-input"
                            :title="'Nome'"
                            :action="setName"
                            :value="registration.name"
                            :type="'text'"
                            :auto="true"
                        />
                        <StandardInput
                            class="new-provider-body-input"
                            :mask="'###.###.###-###'"
                            :title="'CPF'"
                            :value="registration.cpf"
                            :action="setCpf"
                            :auto="true"
                            :type="'text'"
                        />
                    </div>
                    <div class="new-provider-body-input-line">
                        <StandardInput
                            class="new-provider-body-input"
                            :title="'Login '"
                            :value="registration.email"
                            :action="setLogin"
                            :type="'text'"
                            :auto="true"
                        />
                        <StandardInput
                            class="new-provider-body-input"
                            :password="true"
                            :title="'Senha'"
                            :value="registration.password"
                            :action="setPassword"
                            :type="'text'"
                            :auto="true"
                        />
                    </div>
                    <div class="new-provider-body-input-line">
                        <StandardInput
                            class="new-provider-body-input"
                            :title="'Telefone'"
                            :value="registration.phone"
                            :action="setPhone"
                            :type="'text'"
                            :auto="true"
                        />
                        <StandardInput
                            class="new-provider-body-input"
                            :title="'Perfil'"
                            :type="'select'"
                            :value="selectedProfileId"
                            :placeholder="getProfileName(registration.profile) || 'Selecione um perfil'"
                            :list="profileOptions"
                            :action="setProfile"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import SellerService from "../../../services/v3/providers/seller.service";
import ProviderService from "@/services/v3/provider.service";
import ProfileManagementService from "@/services/v3/management/profile.service";

export default {
    mixins: [loaderMixin],
    props: {
        registration: {
            type: Object,
        },
        id: {
            type: Number,
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        StandardButton,
        StandardInput,
    },
    data() {
        return {
            loading: true,
            message: null,
            stores: [],
            provider: {},
            svc: new SellerService(),
            provider_svc: new ProviderService(),
            profile_svc: new ProfileManagementService(),
            profiles: [],
            isLoadingCnpj: false,
            highlightAdress: false,
        };
    },
    watch: {
        "registration.email": function(val) {
            console.log(val);
            this.registration.login = val;
        },
    },
    computed: {
        selectedProfileId() {
            return this.registration && this.registration.profile ? String(this.registration.profile.id) : undefined;
        },
        profileOptions() {
            return this.profiles.map((profile) => ({
                text: profile.name,
                value: String(profile.id),
            }));
        },
    },
    methods: {
        load_provider() {
            if (this.registration.provider_id) {
                this.present_loader("Carregando fornecedor...");
                return this.provider_svc
                    .show(this.registration.provider_id)
                    .then((response) => response.data)
                    .then((data) => {
                        this.provider = data;
                        this.provider.manager = {};
                        this.loading = false;
                        this.dismiss_loader();
                    })
                    .catch((error) => {
                        ErrorHandlerService.handle(error, this.$store);
                    });
            }
            this.loading = false;
        },
        load_profiles() {
            return this.profile_svc
                .list({
                    provider_id: this.registration.provider_id,
                    include_base: true,
                    visibility: "provider",
                    per_page: "all",
                })
                .then((response) => response.data)
                .then((data) => {
                    this.profiles = data.data || data;
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        setName(value) {
            this.registration.name = value;
        },
        setCpf(value) {
            this.registration.cpf = value;
        },
        setLogin(value) {
            this.registration.login = value;
        },
        setPassword(value) {
            this.registration.password = value;
        },
        setPhone(value) {
            this.registration.phone = value;
        },
        getProfileName(profile) {
            return profile ? profile.name : "";
        },
        setProfile(value) {
            const profile = this.profiles.find((item) => String(item.id) === String(value));
            this.$set(this.registration, "profile", profile || null);
        },
        save() {
            this.present_loader("Salvando usuário...");
            this.message = null;
            let callback = (data) => {
                this.dismiss_loader();
                this.$swal.fire("Sucesso!", `Fornecedor ${this.id ? "atualizado" : "criado"} sucesso.`, "success");
                this.close(true);
            };
            let callback_error = (err) => {
                this.dismiss_loader();
                if (err.response && err.response.data && err.response.data.errors) {
                    let errors = err.response.data.errors;
                    this.message = Object.values(errors).flat()[0];
                } else {
                    this.message = "Ops! Houve um erro ao salvar o usuário, tente novamente mais tarde!";
                }
                ErrorHandlerService.handle(err, this.$store);
            };

            if (!this.registration.profile) {
                this.dismiss_loader();
                this.message = "Perfil e obrigatorio!";
                return;
            }

            const payload = {
                registration_id: this.registration.id,
                name: this.registration.name,
                cpf: this.registration.cpf,
                email: this.registration.email,
                login: this.registration.email,
                phone: this.registration.phone,
                password: this.registration.password,
                profile: this.registration.profile,
                provider: {
                    id: this.registration.provider_id,
                },
            };

            this.svc.create(payload).then(callback, callback_error);
        },
        close(reload = false) {
            this.$emit("close", reload);
        },
        handlekeydown(e) {
            if (e.key === "Escape") {
                this.close();
            }
        },
    },
    mounted() {
        this.load_provider();
        this.load_profiles();
        window.addEventListener("keydown", this.handlekeydown);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handlekeydown);
    },
};
</script>

<style lang="scss" scoped>
@import "./new-provider.modalV2";
</style>
